import React, { useRef, useEffect, useState } from 'react';
import '../styles/StickyNotes.css';
import stickyNotesHorizontal from '../assets/stickynotes_hor.png';
import stickyNotesVertical from '../assets/stickynotes_ver.png';

function StickyNotes() {
  const imageRef = useRef(null);
  const [imageLoaded, setImageLoaded] = useState(false);

  useEffect(() => {
    const handleImageLoad = () => {
      setImageLoaded(true);
    };

    if (imageRef.current) {
      if (imageRef.current.complete) {
        handleImageLoad();
      } else {
        imageRef.current.addEventListener('load', handleImageLoad);
        return () => {
          if (imageRef.current) {
            imageRef.current.removeEventListener('load', handleImageLoad);
          }
        };
      }
    }
  }, []);

  const handleObservePointClick = () => {
    window.open('https://observepoint.com', '_blank');
  };

  const handleLinkedInClick = () => {
    window.open('https://www.linkedin.com/in/seojun-chung-aa3067252/', '_blank');
  };

  const handlePortfolioClick = () => {
    window.location.href = '/old';
  };

  return (
    <div className="sticky-notes-container">
      {/* Desktop/Tablet version */}
      <div className="sticky-notes-horizontal">
        <img 
          ref={imageRef}
          src={stickyNotesHorizontal} 
          alt="Seojun Chung - Software Engineer" 
          className="sticky-notes-image"
        />
        
        {/* Clickable areas for horizontal version */}
        <div 
          className="clickable-area observepoint-horizontal"
          onClick={handleObservePointClick}
          title="Visit ObservePoint"
        ></div>
        
        <div 
          className="clickable-area linkedin-horizontal"
          onClick={handleLinkedInClick}
          title="Visit LinkedIn Profile"
        ></div>
        
        <div 
          className="clickable-area portfolio-horizontal"
          onClick={handlePortfolioClick}
          title="View Full Portfolio"
        ></div>
      </div>

      {/* Mobile version */}
      <div className="sticky-notes-vertical">
        <img 
          src={stickyNotesVertical} 
          alt="Seojun Chung - Software Engineer" 
          className="sticky-notes-image"
        />
        
        {/* Clickable areas for vertical version */}
        <div 
          className="clickable-area observepoint-vertical"
          onClick={handleObservePointClick}
          title="Visit ObservePoint"
        ></div>
        
        <div 
          className="clickable-area linkedin-vertical"
          onClick={handleLinkedInClick}
          title="Visit LinkedIn Profile"
        ></div>
        
        <div 
          className="clickable-area portfolio-vertical"
          onClick={handlePortfolioClick}
          title="View Full Portfolio"
        ></div>
      </div>
    </div>
  );
}

export default StickyNotes;
